export async function apiFetch(url, options = {}) {
    const token = localStorage.getItem("token");
    const headers = {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json",
    };
    const res = await fetch(url, { ...options, headers });
    if (res.status === 401 || res.status === 403) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    return res;
  }